import Button from "@/components/Button";
import useModal from "@/hooks/useModal";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import TextField from "@/components/TextField";
import { NumericFormat } from "react-number-format";

export type AdjustRateModalProps = {
  onDismiss: () => void;
  handleBulkAdjustRate: (value: string) => void;
};

export const AdjustRateModal = ({ onDismiss, handleBulkAdjustRate }: AdjustRateModalProps) => {
  const {
    control,
    getValues,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: "onChange"
  });
  const headline = `Adjust Rate by %`;
  const [errorContent] = useState("");
  const { Modal } = useModal();

  async function adjustRate() {
    const value = getValues("percentAdjustment");
    handleBulkAdjustRate(value);
  }

  return (
    <Modal
      onClosed={onDismiss}
      action={<Button onClick={handleSubmit(adjustRate)}>Save</Button>}
      headline={headline}
      className="w-[312px]"
      displayOverflow
    >
      {errorContent ? <div className="text-red-500 font-bold text-center mb-4">{errorContent}</div> : null}

      <p>Adjust selected rates by the following percentage:</p>
      <div className="mt-6">
        <Controller
          name="percentAdjustment"
          control={control}
          rules={{
            required: "Percent Adjustment is required",
            validate: (value) => {
              if (value < 0 || value > 100) {
                return "Percent Adjustment must be between 0% and 100%";
              }
              return true;
            }
          }}
          render={({ field }) => (
            <NumericFormat
              allowedDecimalSeparators={["%"]}
              allowNegative={false}
              decimalScale={2}
              allowLeadingZeros={false}
              disabled={false}
              value={field.value}
              customInput={TextField}
              error={!!errors?.percentAdjustment}
              errorText={errors?.percentAdjustment?.message?.toString()}
              onFocus={(e) => {
                e.target.select();
              }}
              onValueChange={(values) => {
                field.onChange(values.floatValue || 0);
              }}
              trailingIcon="percent"
              label="Percent Adjustment"
              required
              className="w-full"
            />
          )}
        />
      </div>
    </Modal>
  );
};
